const theme = {
    token: {
        colorPrimary: 'rgba(220, 111, 16, 1)',
        colorFillSecondary: '#3e79f7',
        colorBgLayout: '#F5F5F5',
        colorTextSecondary: '#FFFFFF',
    },
    components: {
        Button: {
            colorPrimary: 'rgba(220, 111, 16, 1)',
            colorTextPrimary: "#333",
            colorTextSecondary: '#FFFFFF',
            colorFillSecondary: '#3e79f7',
            colorPrimaryHover: 'rgba(220, 111, 16, 0.5)'
        },
    },
}

export { theme }